import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TravelReimbursementModel } from 'common/models/page-models/travel-reimbursement/travel-reimbursement-data.model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { TravelReimbursementFormWidgetService } from 'common/widget/travel-reimbursement/travel-form.widget.service';

@Injectable({
    providedIn: 'root'
})
export class TravelReimbursementFormResolver extends FormResolverService<TravelReimbursementModel> {
    constructor(
        protected fs: TravelReimbursementFormWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

    override modifyResponseData(dataModel) {
        // console.log(dataModel)
        // if (dataModel.id !== 0) {
        //     dataModel.travelStartDate = new Date(dataModel.travelStartDate);
        //     dataModel.travelEndDate = new Date(dataModel.travelEndDate);
        // }

        if (dataModel.travelStartDate !== null && dataModel.travelEndDate !== null && dataModel.travelDoc !== null ) {
            dataModel.travelStartDate = new Date(dataModel.travelStartDate);
            dataModel.travelEndDate = new Date(dataModel.travelEndDate);
        }
        else
        {
            dataModel.travelStartDate = null;
            dataModel.travelEndDate = null;
        }

        return dataModel;
    }
}
